export default "__VITE_ASSET__CdQvVces__"